import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ContactIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ContactIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.6565 21.1072H11.8717C11.4605 21.1072 11.1268 20.7695 11.1268 20.3532C11.1268 19.9368 11.4605 19.5991 11.8717 19.5991H15.6565C16.0241 19.5991 16.3228 19.2967 16.3228 18.925V10.8201C16.3228 10.4038 16.6565 10.066 17.0678 10.066C17.479 10.066 17.8127 10.4038 17.8127 10.8201V18.925C17.8127 20.1283 16.8457 21.1072 15.6565 21.1072Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.9574 21.8804C12.776 21.8804 13.4395 21.2087 13.4395 20.3801C13.4395 19.5515 12.776 18.8798 11.9574 18.8798C11.1389 18.8798 10.4754 19.5515 10.4754 20.3801C10.4754 21.2087 11.1389 21.8804 11.9574 21.8804Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3908 18.7733H17.0663C16.6551 18.7733 16.3214 18.4356 16.3214 18.0192V10.7214C16.3214 10.3051 16.6551 9.96735 17.0663 9.96735H19.3908C20.8298 9.96735 22 11.1525 22 12.6091V16.1316C22 17.5882 20.8298 18.7733 19.3908 18.7733ZM17.8112 17.2652H19.3908C20.0082 17.2652 20.5101 16.7565 20.5101 16.1316V12.6091C20.5101 11.9841 20.0082 11.4755 19.3908 11.4755H17.8112V17.2652Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.93416 18.7733H4.60967C3.17074 18.7733 2 17.5882 2 16.1316V12.6091C2 11.1525 3.17074 9.96735 4.60967 9.96735H6.93416C7.34542 9.96735 7.67909 10.3051 7.67909 10.7214V18.0192C7.67909 18.4356 7.34542 18.7733 6.93416 18.7733ZM4.60967 11.4755C3.99229 11.4755 3.48985 11.9841 3.48985 12.6091V16.1316C3.48985 16.7565 3.99229 17.2652 4.60967 17.2652H6.18924V11.4755H4.60967Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.6639 11.4097C19.2526 11.4097 18.9189 11.1049 18.9189 10.6885V10.6227C18.9189 6.76053 15.8151 3.61852 12.0002 3.61852C8.18492 3.61852 5.08105 6.76053 5.08105 10.6227C5.08105 11.0391 4.74739 11.4097 4.33613 11.4097C3.92487 11.4097 3.5912 11.1048 3.5912 10.6885C3.5912 5.92888 7.36336 2.11035 12.0002 2.11035C16.6366 2.11035 20.4088 5.92887 20.4088 10.6227C20.4088 11.0391 20.0751 11.4097 19.6639 11.4097Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ContactIcon;
